import type { CSSObject } from '@emotion/react';
import { css, Global } from '@emotion/react';
import { useAppSelector } from '../grid/reduxStore/Store.ts';
import { selectTableTextDefaultStyles, selectTextDefaultStyles } from '../grid/reduxStore/textDefaultStylingSlice';
import { tiptapDefaultStyle } from '../GridDndEditor/TiptapEditor/tiptapDefaultStyle';
import { sharedTableStyles } from '../grid/reduxStore/textDefaultStylingSlice';
import { mapTableStylesToAllBlocks } from './mapTableStylesToAllBlocks.ts';
import type { AllTextDefaultStylesType } from '../grid/reduxStore/textDefaultStylingSlice';

export const pricingTableTotalStyles = {
  fontWeight: 'bold',
  textAlign: 'right',
};

// A list item without its own color gets its bullet from the <li>, so match the paragraph default
export const listItemMarkerStyles = (paragraphColor: AllTextDefaultStylesType['color'] | undefined) => ({
  '.editor__page__draggable .tiptap li:has(> p)': { color: paragraphColor },
});

const TextDefaultStylesLoader = () => {
  const textDefaultStyles = useAppSelector(selectTextDefaultStyles);
  const tableTextDefaultStyles = useAppSelector(selectTableTextDefaultStyles);

  const { textBlockTableStyles, numberBlockStyles } = mapTableStylesToAllBlocks(tableTextDefaultStyles);

  const blocksWithTiptapStyle = {
    '.editor__page__draggable .tiptap': {
      ...textDefaultStyles,
      ...textBlockTableStyles,
    },
    ...listItemMarkerStyles(textDefaultStyles.p.color),
    '.editor__page__draggable': {
      '.py-darkGrey-row .tiptap': { ...sharedTableStyles, fontWeight: 'bold' },
      '.py-total-row .tiptap p:not([data-table-style])': pricingTableTotalStyles,
      '.py-subtotal-row .tiptap p:not([data-table-style])': pricingTableTotalStyles,
      ...numberBlockStyles,
    },
    ...tiptapDefaultStyle,
  };
  return <Global styles={css(blocksWithTiptapStyle as unknown as CSSObject)} />;
};

export default TextDefaultStylesLoader;
